import IconComponent from 'app_components/commons/icons';
import React, {CSSProperties} from 'react';
import { AiOutlineDelete, AiOutlineEye } from 'react-icons/ai';
import { FaSave } from 'react-icons/fa';
import './outlineButtonEditor.scss'

export interface OutlineButtonEditorProps {
  type: 'save' | 'view' | 'delete' | 'edit'
  className?: string
  style?: CSSProperties
  onClick?: ()=>void
}

const OutlineButtonEditor: React.SFC<OutlineButtonEditorProps> = (props) => {

  const getIconFromType = () => {
    switch(props.type){
      case 'delete':
        return(
          <AiOutlineDelete className='icon_button' />
        )
      case 'edit':
        return(
          <IconComponent svg='Edit' class_name='icon_button' />
        )
      case 'save':
        return(
          <FaSave className='icon_button' />
        )
      case 'view':
        return(
          <AiOutlineEye className='icon_button' />
        )
      default:
        return(
          <AiOutlineDelete className='icon_button' />
        )
    }
  }

  return (
    <div
      className={`outline_button_editor-layout ${props.className ? props.className : ''}`}
      style={props.style}
      onClick={props.onClick}
    >
      {getIconFromType()}
    </div>
  );
}

export default OutlineButtonEditor;
